export default __webpack_public_path__ + "static/media/closet5-after3-768w.1ebdda7a.avif";